<template>
    <el-dialog title="⚠️ 设备维保提醒" v-model="localVisible" width="70%" :close-on-click-modal="false" :z-index="2000"
        append-to-body modal-append-to-body :show-close="false" @close="handleClose">
        <div class="warn-content">
            <div class="warn-title">
                <i class="el-icon-warning-outline"></i>
                <span>发现 {{ expiredDeviceList.length }} 台设备已过维保时间，请及时处理！</span>
            </div>
            <el-table :data="expiredDeviceList" border stripe style="margin-top: 15px;">
                <el-table-column prop="deviceName" label="设备名称" min-width="150" />
                <el-table-column prop="deviceType" label="设备类型" min-width="120" />
                <el-table-column prop="nextMaintenance" label="应维保时间" min-width="180">
                    <template #default="scope">
                        {{ formatTime(scope.row.nextMaintenance) }}
                    </template>
                </el-table-column>
                <el-table-column prop="roomId" label="所属功能间" min-width="120">
                    <template #default="scope">
                        {{ getRoomName(scope.row.roomId) }}
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <template #footer>
            <el-button type="primary" @click="handleClose">我知道了</el-button>
            <el-button type="primary" @click="handleGotoMaintenance">去维保</el-button>
        </template>
    </el-dialog>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        expiredDeviceList: {
            type: Array,
            default: () => []
        },
        roomList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            // 定义本地变量，初始值同步父组件传入的 visible
            localVisible: this.visible
        };
    },
    watch: {
        // 监听父组件 props 变化，同步到本地变量
        visible(newVal) {
            this.localVisible = newVal;
        }
    },
    methods: {
        formatTime(timeStr) {
            if (!timeStr) return "未设置";
            try {
                const date = new Date(timeStr);
                return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
            } catch (error) {
                return timeStr;
            }
        },
        getRoomName(roomId) {
            const room = this.roomList.find(item => item.id === roomId);
            return room ? room.roomName : '未知功能间';
        },
        handleClose() {
            // 先更新本地变量关闭弹窗，再通知父组件
            this.localVisible = false;
            this.$emit('close');
        },
        handleGotoMaintenance() {
            // 去维保时也先关闭弹窗，再通知父组件
            this.localVisible = false;
            this.$emit('goto-maintenance');
        }
    }
};
</script>

<style lang="scss" scoped>
.warn-content {
    .warn-title {
        display: flex;
        align-items: center;
        color: #e6a23c;
        font-size: 15px;
        font-weight: 500;
        margin-bottom: 10px;

        i {
            font-size: 20px;
            margin-right: 8px;
        }
    }
}
</style>